export const ERROR_RECEIVE = 'ERROR_RECEIVE'

export const GETNEWMSGNO_REQUEST = 'GETNEWMSGNO_REQUEST'
export const GETNEWMSGNO_RECEIVE = 'GETNEWMSGNO_RECEIVE'

export const GETCATEGORYLIST_REQUEST = 'GETCATEGORYLIST_REQUEST'
export const GETCATEGORYLIST_RECEIVE = 'GETCATEGORYLIST_RECEIVE'

export const GETFAQCONTENTLIST_REQUEST = 'GETFAQCONTENTLIST_REQUEST'
export const GETFAQCONTENTLIST_RECEIVE = 'GETFAQCONTENTLIST_RECEIVE'

export const GETFAQCONTENTINFO_REQUEST = 'GETFAQCONTENTINFO_REQUEST'
export const GETFAQCONTENTINFO_RECEIVE = 'GETFAQCONTENTINFO_RECEIVE'

export const SUBMITQUESTION_REQUEST = 'SUBMITQUESTION_REQUEST'
export const SUBMITQUESTION_RECEIVE = 'SUBMITQUESTION_RECEIVE'

export const SUBMITQUMSGTEXT_REQUEST = 'SUBMITQUMSGTEXT_REQUEST'
export const SUBMITQUMSGTEXT_RECEIVE = 'SUBMITQUMSGTEXT_RECEIVE'

export const SUBMITQUMSGATTR_REQUEST = 'SUBMITQUMSGATTR_REQUEST'
export const SUBMITQUMSGATTR_RECEIVE = 'SUBMITQUMSGATTR_RECEIVE'

export const GETHSTQULIST_REQUEST = 'GETHSTQULIST_REQUEST'
export const GETHSTQULIST_RECEIVE = 'GETHSTQULIST_RECEIVE'

export const GETHSTQUMSGLIST_REQUEST = 'GETHSTQUMSGLIST_REQUEST'
export const GETHSTQUMSGLIST_RECEIVE = 'GETHSTQUMSGLIST_RECEIVE'

export const SUBMITEVALUATE_REQUEST = 'SUBMITEVALUATE_REQUEST'
export const SUBMITEVALUATE_RECEIVE = 'SUBMITEVALUATE_RECEIVE'

export const SAVEUNKNOWNQU_REQUEST = 'SAVEUNKNOWNQU_REQUEST'
export const SAVEUNKNOWNQU_RECEIVE = 'SAVEUNKNOWNQU_RECEIVE'

export const SEARCHFAQ_REQUEST = 'SEARCHFAQ_REQUEST'
export const SEARCHFAQ_RECEIVE = 'SEARCHFAQ_RECEIVE'

export const REPORT_REQUEST = 'REPORT_REQUEST'
export const REPORT_RECEIVE = 'REPORT_RECEIVE'

export const UPDATEMSGSTATUS_REQUEST = 'UPDATEMSGSTATUS_REQUEST'
export const UPDATEMSGSTATUS_RECEIVE = 'UPDATEMSGSTATUS_RECEIVE'

export const GETFAQVERSION_REQUEST = 'GETFAQVERSION_REQUEST'
export const GETFAQVERSION_RECEIVE = 'GETFAQVERSION_RECEIVE'